import React from "react";
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button,
} from "reactstrap";
import TemplateCategoryBrowser from "./TemplateCategoryBrowser";

export default function TemplateLibraryModal({ strategyType, onClose, onImport, importing }) {
  return (
    <Modal isOpen toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>
        Template Library — {strategyType}
      </ModalHeader>

      <ModalBody>
        <TemplateCategoryBrowser
          strategyType={strategyType}
          onImport={onImport}
          importing={importing}
        />
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" outline onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}
